import styles from './SearchBar.module.scss';

const SearchBar = (props) => {
    const { placeholder, onSearch, onFocus } = props;

    const onType = (e) => onSearch(e.target.value.toLowerCase());

    return (
        <div className={styles.searchBar}>
            <div className={styles.searchIcon}>
                <img src="/images/search_icon.svg" alt="" />
            </div>
            <input
                className={styles.searchInput}
                type="search"
                placeholder={placeholder}
                onKeyUp={onType}
                onFocus={onFocus}
            />
        </div>
    );
};

export default SearchBar;
